import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  DialogActions,
  DialogHeader,
  IconButton,
  IconStatusWrapper,
} from '@afosto/components';
import { Rotate, Times } from '@afosto/icons/solid';
import { Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import Icon from '../../../Icon';
import translations from '../../translations';

const FailedPrintJobs = ({
  failedJobs,
  onChangePrinter,
  onRetryJob,
  onRetryAllJobs,
  isPrinting,
  onClose,
  selectedPrinter,
}) => {
  const intl = useIntl();

  return (
    <>
      <DialogHeader
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <IconStatusWrapper
              color="error"
              invertColors
              icon={Times}
              IconComponent={Icon}
              size="small"
              variant="rounded"
            />
            <FormattedMessage {...translations.printingFailed} />
          </Box>
        }
        onClose={onClose}
        sx={{ position: 'sticky', zIndex: 2, top: 0, backgroundColor: 'common.white' }}
      />

      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {selectedPrinter && (
          <Card sx={{ px: 2.5, py: 2 }}>
            <Typography fontWeight={500}>
              <FormattedMessage {...translations.printer} />
            </Typography>
            <Typography>{selectedPrinter?.name}</Typography>
          </Card>
        )}
        <Card>
          <CardHeader
            title={intl.formatMessage(translations.failedJobsTitle)}
            titleTypographyProps={{ fontWeight: 500, variant: 'bodyMedium' }}
            sx={{ bgcolor: 'gray.25', py: 1, px: 2.5 }}
          />
          {failedJobs.map((job, idx) => (
            <Box
              key={job.id}
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: 2.5,
                py: 1,
                gap: 3,
                width: '100%',
                ...(idx + 1 !== failedJobs.length
                  ? {
                      borderBottom: theme => `1px solid ${theme.palette.divider}`,
                    }
                  : {}),
              }}
            >
              <Typography
                component="span"
                sx={{ flex: 1, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
              >
                {job.content.split('/').at(-1).split('?').at(0)}
              </Typography>
              <IconButton
                sx={{ ml: 'auto' }}
                variant="outlined"
                size="small"
                onClick={onRetryJob(job)}
              >
                <Icon icon={Rotate} />
              </IconButton>
            </Box>
          ))}
        </Card>
      </CardContent>

      <DialogActions
        sx={{ position: 'sticky', mt: 'auto', bottom: 0, backgroundColor: 'common.white' }}
      >
        <Button onClick={onChangePrinter} variant="outlined" color="secondary" size="large">
          <FormattedMessage {...translations.retryDifferentPrinter} />
        </Button>
        <Button size="large" onClick={onRetryAllJobs} loading={isPrinting}>
          <FormattedMessage {...translations.tryAgain} />
        </Button>
      </DialogActions>
    </>
  );
};

export default FailedPrintJobs;
